import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function OurTeams() {
  const teamMembers = [
    {
      name: "Dr Sudarshan V",
      img: "/img/teams-08.png",
      exp: "10+ Years of Exp",
      spec: "MBBS,MS,FMAS,EFIAGE",
      desc: "MBBS, MS, FMAS, EFIAGES General and Laparoscopic surgeon. Is a compassionate and dedicated surgeon, with a keen eye for detail and precision.",
    },
    {
      name: "Aperna Tej",
      img: "/img/teams-02.png",
      exp: "15+ Years of Exp",
      spec: "Physiotherapist",
      desc: "Senior Physiotherapist with 15+ years of experience in joint care, musculoskeletal health, and geriatrics. She is also trained in treating stroke patients.",
    },
    {
      name: "Dr Sarita R.",
      img: "/img/teams-12.png",
      exp: "15+ Years of Exp",
      spec: "Obstetrician and Gynecologist",
      desc: "Obstetrician and gynecologist with 15+ years of experience. Trained in advanced laparoscopic procedures and member of minimal access surgery.",
    },
    {
      name: "Siddharth Sakelle",
      img: "/img/teams-04.png",
      exp: "20+ Years of Exp",
      spec: "BPT, Masters in Orthopedic",
      desc: "20+ years of experience in physiotherapy. Head Physiotherapist at Prakash Padukone Badminton Academy.",
    },
    {
      name: "Dr. Shantala.J",
      img: "/img/famPhy-team-17.png",
      exp: "10+ Years of Exp",
      spec: "Fellowship in Pediatric",
      desc: "MBBS,DNB – Pediatrics with 10+ years of experience. Fellowship in Pediatric Endocrinology and Adolescent Endocrinology. Available in FamPhy Clinics every evening Monday to Saturday on appointments.",
    },
    {
      name: "Ms.Vrinda Pandey",
      img: "/img/famPhy-team-20.png",
      exp: "18+ Years of Exp",
      spec: "Clinical Dietician and Health coach",
      desc: "Clinical Dietician and Health coach with 18 years of experience in diet counselling. Worked with corporate hospitals and educational institutions.",
    },
    {
      name: "Dr. Rajimol Raju",
      img: "/img/famPhy-team-21.png",
      exp: "Experienced",
      spec: "BPT(Physiotherapy)",
      desc: "Specialized in post-stroke rehabilitation with expertise in restoring motor function and improving quality of life for stroke survivors. Expertise in traumatic brain injury rehabilitation.",
    },
    {
      name: "Dr Priyanka S",
      img: "/img/famPhy-team-22.jpg",
      exp: "15+ Years of Exp",
      spec: "Physician & Diabetologist",
      desc: "Physician & Diabetologist with special interest in Endocrinology and 15+ years of experience. MBBS, FEDM, FACE(USA), CCEBDM, CCGDM, CCMTD. Has worked at several renowned hospitals.",
    },
    {
      name: "Dr. Arshiya Tabassum",
      img: "/img/famPhy-team-23.png",
      exp: "10+ Years of Exp",
      spec: "MBBS, MD Physician",
      desc: "Medical graduate with 10 years of experience. Worked in various multispeciality hospitals.",
    },
    {
      name: "Dr. Avinash Kumar Verma",
      img: "/img/Dr Avinash.jpeg",
      exp: "40+ years of Experience",
      spec: "Physician (MBBS)",
      desc: "MBBS graduate from S.K. Medical College, Bihar, with extensive experience across multiple hospitals. Former Chief Medical Officer and Senior Medical Officer at BCCL, Dhanbad.",
    },
    {
      name: "Dr. Prem Kishore Srivastava",
      img: "/img/Dr Premkumar.jpeg",
      exp: "36+ years",
      spec: "Dermatology, Venereology & Leprology (MBBS, MD)",
      desc: "Senior dermatologist with 36+ years of experience and former association with Aster. Expertise in acne, pigmentation, psoriasis, vitiligo, and advanced skin procedures.",
    },
    {
      name: "Dr. Sankeerthana Kamini",
      img: "/img/Dr Sankeerthana.jpeg",
      exp: "10+ years",
      spec: "Pediatrics & Neonatology",
      desc: "Specialist Pediatrician and Neonatologist with 10+ years of experience, including dedicated pediatric practice and NICU care for high-risk newborns. Certified breastfeeding and infant feeding counsellor with a focus on newborn care, growth, and development.",
    },
    {
  name: "Ramitha Ramesh",
  img: "/img/ramitha.webp",
  exp: "Couples Therapist",
  spec: "Master's in Clinical Psychology (TISS)",
  desc: "Ramitha Ramesh is a psychotherapist and couples therapist with a Master's in Clinical Psychology from TISS. She specializes in trauma, relationships, anxiety, self-esteem, and life transitions. Her integrative approach combines CBT, Transactional Analysis, EMDR, Human-Centered Therapy, Existential Therapy, and the Gottman Method to provide compassionate, evidence-based, and personalized care in a safe, inclusive, and trauma-informed environment.",
},
{
  name: "Dr. Naveen Kumar R",
  img: "/img/naveen.webp",
  exp: "9+ Years of Exp",
  spec: "MBBS, DNB (Orthopaedics), D. Ortho, FIASM",
  desc: "Dr. Naveen Kumar R is a Fellowship-trained Orthopaedic Surgeon with over nine years of experience in treating musculoskeletal disorders, trauma, sports injuries, and degenerative joint conditions. He completed his D. Ortho, DNB in Orthopaedics, and advanced Fellowship training in Arthroscopy and Sports Medicine. Currently serving as a Consultant Orthopaedic Surgeon at MVJ Medical College & Research Hospital, he is committed to evidence-based, patient-centered care with a focus on accurate diagnosis, personalized treatment, and restoring mobility, function, and overall quality of life.",
},
{
  name: "Dr. Farzana M Shaikh",
  img: "/img/farzana.jpg",
  exp: "Experienced Physiotherapist",
  spec: "BPT (Physiotherapist)",
  desc: "Specialized in post-stroke rehabilitation, orthopedic and musculoskeletal rehabilitation, post-operative rehabilitation, knee and joint replacement rehabilitation, fracture and injury rehabilitation, neurological rehabilitation, pediatric physiotherapy, strength, balance and mobility training, and functional rehabilitation.",
},
  ];

  return (
    <>
      <Helmet>
        <title>
          Best Family Doctors at your Door Step in Bengaluru and Delhi
        </title>

        <meta
          name="description"
          content="We provide experienced family physicians with 15+ years of expertise, offering trusted home healthcare services in Bengaluru."
        />

        <meta
          name="keywords"
          content="talk to a doctor, doctor visit at home"
        />
      </Helmet>

      <div className="container">
        <div className="ourteam-section">
          <h2>
            Our Team of <span>Doctors</span>
          </h2>

          <p className="limit-width">
            Specialized and general physicians who have many years of work
            experience in their respective fields
          </p>

          <div className="team-flex">
            {teamMembers.map((doc, i) => (
              <div className="team-card" key={i}>
                <div className="teamimg">
                  <img
                    className="img-fluid"
                    src={`${process.env.PUBLIC_URL}${doc.img}`}
                    alt={doc.name}
                  />
                </div>

                <div className="teamcontent">
                  <h5>{doc.name}</h5>

                  <p>{doc.desc}</p>

                  <div className="ext-content">
                    <span className="exp-yers">{doc.exp}</span>

                    <span className="mst-in">{doc.spec}</span>
                  </div>

                  <div className="team-btn-box">
                    <Link to="/contacts" className="btn theam-btn-m">
                      Consult
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}